import React from 'react';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    ...theme.margin,
    [theme.breakpoints.up('md')]: {
      ...theme.marginBig,
    },
    height:'100vh',

  },
  dataBackground: {
    background: "blue"
  },
  color: {
    color: '#26bbed'
  }
});

const Loader = (props) => {

  const { classes } = props;
  return (
    <Grid
      container
      className = { classes.root }
      direction  ='column'
      justify    = 'center'
      alignItems ='center'
    >
    <CircularProgress 
      color="primary" 
      classes={{
          colorPrimary: classes.color
      }}
    />
  </Grid>
  );
}


export default withStyles(styles)(Loader);
